<template>
    <div class="px-5 d2d-onboarding">
        <div class="row d2d-header mb-5">
            <div class="col-md-12 pt-4">
                <h1>Welcome to SilencerCo’s Dealer Commission Program</h1>
            </div>
            <div class="col-md-12 d2d-h-subtitle pt-2">
                <span>EARN COMMISSION</span> ON SUPPRESSOR SALES FROM
                <a href="https://www.silencerco.com" target="_blank">
                    SILENCERCO.COM
                </a>
            </div>
            <div class="col-md-12 py-3 mt-3 mb-2">
                <router-link
                    class="d2d-btn"
                    to="/direct-to-dealer-onboarding"
                    v-if="!currentLocationIsOnboarded"
                >
                    SIGN UP NOW
                </router-link>

                <div class="d2d-btn mx-auto" v-else>ENROLLED</div>
            </div>
        </div>

        <div class="section mt-5" v-if="locations.length > 1">
            <div class="row">
                <div class="col-md-12 p-0 text-center">
                    <h3>LOCATIONS SIGNED UP</h3>
                </div>
                <br />
                <div>
                    <table
                        class="table table-responsive table-striped border-bottom mt-2"
                    >
                        <thead class="thead-light">
                            <tr>
                                <th>Name</th>
                                <th>Address</th>
                                <th>City</th>
                                <th>State</th>
                                <th>Zip</th>
                                <th>Commission Status</th>
                                <th>SIGN UP</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(location, index) in locations"
                                :key="index"
                            >
                                <td class="location-name">
                                    {{ location.name }}
                                </td>
                                <td>{{ location.address }}</td>
                                <td>{{ location.city }}</td>
                                <td>{{ location.zip_code }}</td>
                                <td>{{ location.state }}</td>
                                <td class="bold">
                                    <!-- <span
                                        v-if="
                                            location.direct_to_dealer_onboarding !=
                                            null
                                        "
                                        class="badge badge-success px-2 py-1"
                                        >ENROLLED</span
                                    > -->
                                    <span
                                        v-if="
                                            location.direct_to_dealer_onboarding?.document_file_path != null || 
                                            location.direct_to_dealer_onboarding?.onboarding_status == 'active'
                                        "
                                        class="badge badge-success px-2 py-1"
                                        >ENROLLED</span
                                    >
                                    <span v-else>Not enrolled</span>
                                </td>
                                <td class="bold">
                                    <span
                                        v-if="
                                            location.direct_to_dealer_onboarding == null || 
                                            (location.direct_to_dealer_onboarding?.onboarding_status == 'pending' && location.direct_to_dealer_onboarding?.document_file_path == null) || 
                                            location.direct_to_dealer_onboarding?.onboarding_status == 'inactive'
                                        "
                                        class="badge badge-warning px-2 py-1 sign-up-badge"
                                        @click="goToOnboarding(location.id)"
                                        >SIGN UP NOW</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br /><br />
                </div>
            </div>
        </div>

        <div class="section">
            <div class="row">
                <div class="col-md-12 p-0">
                    <h2>How It Works</h2>
                </div>
            </div>
            <div class="row step-container">
                <div class="col-md-6 step-sub-container">
                    <div class="step-holder">
                        <div class="step-text">STEP</div>
                        <div class="step-number">01</div>
                    </div>
                    <div class="step-info">
                        Customer purchases suppressor on
                        <a href="https://www.silencerco.com" target="_blank">
                            silencerco.com.
                        </a>
                    </div>
                </div>
                <div class="col-md-6 step-sub-container">
                    <div class="step-holder">
                        <div class="step-text">STEP</div>
                        <div class="step-number">02</div>
                    </div>
                    <div class="step-info">
                        Customer selects <span>you</span> as their transfer
                        dealer.
                    </div>
                </div>
            </div>
            <div class="row step-container">
                <div class="col-md-6 step-sub-container">
                    <div class="step-holder">
                        <div class="step-text">STEP</div>
                        <div class="step-number">03</div>
                    </div>
                    <div class="step-info">
                        SilencerCo <span>forms and transfers</span> the
                        suppressor to you.
                    </div>
                </div>
                <div class="col-md-6 step-sub-container">
                    <div class="step-holder">
                        <div class="step-text">STEP</div>
                        <div class="step-number">04</div>
                    </div>
                    <div class="step-info">
                        You receive a <span>commission check</span> from
                        SilencerCo.
                    </div>
                </div>
            </div>
        </div>
        <div class="section mt-5">
            <div class="row">
                <div class="col-md-12 p-0">
                    <h2>
                        General Terms
                        <span
                            style="
                                font-size: 10px;
                                color: black;
                                font-weight: normal;
                            "
                            >(see agreement for full terms)</span
                        >
                    </h2>
                </div>
                <div>
                    <ol>
                        <li>
                            You will receive a flat commission on each of the
                            suppressors sold where a customer selects your
                            dealership as their transferring dealer.
                        </li>
                        <li>
                            All commission payments will be paid the following
                            month via ACH transfer.
                        </li>
                        <li>You must have a valid FFL and SOT.</li>
                        <li>
                            You cannot charge the customer a transfer fee, but
                            you can charge up to $100 in eForm filing fees.
                        </li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="section mt-3">
            <div class="row">
                <div class="col-md-12 p-0">
                    <h2>You can earn up to <span> $200 per silencer:</span></h2>
                </div>
            </div>
        </div>
        <div class="accordion mt-6" id="accordionSilencers">
            <div
                class="accordion-item"
                v-for="(item, index) in silencers"
                :key="index"
            >
                <h2 class="accordion-header" :id="'heading' + index">
                    <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#collapse' + index"
                        aria-expanded="false"
                        :aria-controls="'collapse' + index"
                    >
                        {{ item.name }}
                    </button>
                </h2>
                <div
                    :id="'collapse' + index"
                    class="accordion-collapse collapse"
                    :aria-labelledby="'heading' + index"
                    data-bs-parent="#accordionSilencers"
                >
                    <div class="accordion-body">
                        <div></div>
                        <div class="row">
                            <div class="col-sm-4 theader">SILENCER</div>
                            <div class="col-sm-4 theader">SKU</div>
                            <div class="col-sm-4 theader">COMMISSION</div>
                        </div>
                        <div
                            class="row trow"
                            v-for="silencer in item.data"
                            :key="index"
                        >
                            <div class="col-sm-4 tbody">
                                {{ silencer.name }}
                            </div>
                            <div class="col-sm-4 tbody font-weight-bold">
                                {{ silencer.sku }}
                            </div>
                            <div class="col-sm-4 tbody">
                                $ {{ silencer.commission }}
                                <img
                                    v-if="silencer.starred"
                                    src="/images/starred.png"
                                    class="starred"
                                />
                                <span
                                    class="high-earner"
                                    v-if="silencer.starred"
                                    >High Earner</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section mt-5">
            <div class="section">
                <div class="row">
                    <div class="col-md-12 p-0">
                        <h2>How Do I Sign Up?</h2>
                    </div>
                    <div class="col-md-12 p-0 mt-2">
                        <p>
                            Click the button below to get started and sign the
                            required agreements. Once completed, you will be
                            added as an available transfer dealer on the
                            silencerco.com website.
                        </p>
                    </div>
                    <div class="col-md-12 p-0 mt-4">
                        <router-link
                            class="d2d-btn"
                            to="/direct-to-dealer-onboarding"
                            v-if="!currentLocationIsOnboarded"
                        >
                            SIGN UP NOW
                        </router-link>

                        <div class="d2d-btn text-center" v-else>ENROLLED</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapGetters } from "vuex";
export default {
    props: [],
    emits: [],
    components: {},
    setup() {
        const store = useStore();
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });

        let user = computed(function () {
            return store.state.user;
        });

        return {
            store,
            user,
        };
    },
    data() {
        return {
            locationId: "",
            silencers: {
                rifle: {
                    name: "Rifle Silencers",
                    data: [
                        {
                            name: "Scythe-Ti",
                            sku: "SU5328",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                        {
                            name: "Omega 300 DTM",
                            sku: "SU4735",
                            commission: "200",
                            starred: true,
                            high_earner: true,
                        },
                        {
                            name: "Omega 36M",
                            sku: "SU4735",
                            commission: "200",
                            starred: true,
                            high_earner: true,
                        },
                        {
                            name: "Hybrid 46 DTM",
                            sku: "SU5107",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                        {
                            name: "Hybrid 46M",
                            sku: "SU5107",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                        {
                            name: "Chimera 300",
                            sku: "SU2616",
                            commission: "175",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "Saker 556K ASR",
                            sku: "SU2256",
                            commission: "175",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "Velos LBP",
                            sku: "SU5059",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                    ],
                },
                pistol: {
                    name: "Pistol Silencers",
                    data: [
                        {
                            name: "OSPREY 45 2.0",
                            sku: "SU5185",
                            commission: "150",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "OSPREY 9 2.0",
                            sku: "SU5184",
                            commission: "150",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "OMEGA 45K",
                            sku: "SU2254",
                            commission: "130",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "OMEGA 9K",
                            sku: "SU1544",
                            commission: "130",
                            starred: false,
                            high_earner: false,
                        },
                    ],
                },
                rimfire: {
                    name: "Rimfire Silencers",
                    data: [
                        {
                            name: "SPARROW 22",
                            sku: "SU75",
                            commission: "60",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "SWITCHBACK",
                            sku: "SU5085",
                            commission: "100",
                            starred: false,
                            high_earner: false,
                        },
                    ],
                },
                shotgun: {
                    name: "Shotgun Silencers",
                    data: [
                        {
                            name: "SALVO 12",
                            sku: "SU823",
                            commission: "200",
                            starred: false,
                            high_earner: false,
                        },
                    ],
                },
            },
            locations: [],
        };
    },
    mounted() {
        if (this.user?.is_d2c_enabled === 0) {
            this.$router.push({ name: "dashboard" });
        }
        this.getLocations();
    },
    methods: {
        getLocations() {
            axios
                .post("/api/get-locations", { user_id: this.user.id })
                .then((data) => {
                    this.locations = data.data.result;
                    if (data.data.result.length == 1) {
                        this.locationId = data.data.result[0].id;
                        // this.populateFields();
                    }
                });
        },
        goToOnboarding(id) {
            this.$router.push({
                name: "directToDealerOnboarding",
                params: { id: id },
            });
        },
    },
    computed: {
        currentLocationIsOnboarded() {
            if (this.locationId != "" && this.locationId != null) {
                let index = this.locations.findIndex(
                    (item) => item.id == this.locationId
                );
                if (index != -1) {
                    if (
                        this.locations[index].direct_to_dealer_onboarding !=
                        null
                    ) {
                        if (
                            this.locations[index].direct_to_dealer_onboarding
                                .signing_session_data != null
                        ) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
    },
};
</script>
<style scoped lang="scss">
.btn-join-d2d {
    font-size: 12px;
    word-wrap: break-word;
    white-space: break-spaces;
}
.btn-join-d2d:hover,
.btn-join-d2d.active {
    color: white !important;
}

.d2d-header {
    text-align: center;
    background: #ededed;
    padding: 20px;
    border-radius: 30px;
    h1 {
        font-size: 2rem;
        color: #000000;
    }
    .d2d-h-subtitle {
        font-size: 1.6rem;
        font-weight: 600;
        color: #000000;
        span {
            font-weight: 800;
            font-family: "TT-Norms-ExtraBold";
        }
    }
}

.d2d-onboarding {
    @media (max-width: 600px) {
        width: 100%;
        padding: 1rem !important;
    }
    width: 80%;
    margin: auto;
    h2 {
        font-size: 2rem;
        color: #000000;
    }

    .step-container {
        display: flex;
        gap: 20px;
        margin-top: 10px;
        margin-bottom: 20px;
        .step-sub-container {
            @media (max-width: 600px) {
                width: 100%;
                padding: 1rem !important;
            }
            flex: 1;
            padding: 25px;
            background: #2d2b29;
            display: flex;
            color: white;
            gap: 20px;
            border-radius: 12px;
            width: 49%;
            .step-holder {
                .step-text {
                    font-size: 28px;
                    font-family: "TT-Norms-ExtraBold";
                }
                .step-number {
                    font-size: 50px;
                    color: #ff7f00;
                    font-family: "TT-Norms-ExtraBold";
                    margin-top: -25px;
                }
            }
            .step-info {
                width: 80%;
                margin: auto;
                font-size: 22px;
                span {
                    color: #ff7f00;
                }
            }
        }
    }

    .d2d-btn {
        width: 225px;
        height: 45px;
        border-radius: 50px;
        background: #ff7f00;
        color: white;
        border-color: #ff7f00;
        font-weight: 500;
        border: 1px solid #ff7f00;
        padding: 10px 30px;
        &:hover {
            color: #ff7f00;
            background-color: transparent;
        }
        font-family: "TT-Norms-ExtraBold";
    }

    a {
        color: #ff7f00;
        text-decoration: none;
    }

    ol {
        padding: 0;
        font-size: 18px;
        line-height: 2rem;
        color: black;
        padding-left: 5px;
    }
    p {
        color: black;
    }
    h2 {
        span {
            color: #ff7f00;
        }
    }
    .accordion-button {
        font-size: 25px;
    }

    .accordion {
        max-width: 550px;
        margin-left: 45px;
        margin-top: 10px;
        @media (max-width: 600px) {
            margin-left: 0px;
        }
    }

    .accordion-button:not(.collapsed) {
        background: none;
        color: #ff7f00;
    }
    .accordion-button.collapsed::after {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 15px;
        height: 15px;
        border-bottom: 3px solid;
        border-right: 3px solid;
        transform: rotate(45deg);
        left: 4px;
        top: 30%;
        background-image: unset;
        right: 25px;
        color: #ff7f00;
    }

    .accordion-button:not(.collapsed)::after {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 15px;
        height: 15px;
        border-bottom: 3px solid;
        border-right: 3px solid;
        transform: rotate(225deg);
        left: 4px;
        top: 40%;
        background-image: unset;
        right: 25px;
        color: #ff7f00;
    }
    .accordion-item {
        border: unset;
        border-top: 2px solid #efefefef;
    }
    .theader {
        font-size: 18px;
        color: #bcbcbc;
        margin-bottom: 5px;
    }
    .tbody {
        font-size: 18px;
        color: #000000;
    }
    .starred {
        vertical-align: baseline;
        margin-left: 5px;
        margin-right: 5px;
        width: 12px;
    }
    .high-earner {
        font-size: 12px;
        color: #ff7f00;
        font-style: italic;
    }
    .accordion-body {
        .trow {
            border-top: 1px solid #fefe;
            padding-top: 5px;
            padding-bottom: 5px;
        }
    }
}
.location-name {
    color: #000000 !important;
    text-transform: uppercase;
    font-weight: 800;
    font-family: "TT-Norms-ExtraBold";
}

.bold {
    font-family: "TT-Norms-ExtraBold";
    color: #000000 !important;
}

.sign-up-badge {
    background-color: #ff7f00 !important;
    font-family: "TT-Norms-ExtraBold";
    padding: 5px 20px 5px 20px !important;
    font-size: 12px;
}

.sign-up-badge:hover {
    cursor: pointer;
}
</style>
